// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"507":"join","792":"main"}[chunkId] + "." + {"507":"ea9b07ae","792":"601447ff"}[chunkId] + ".css";
};